import angular from 'angular';
import moment from 'moment';

import './event-date-modal.style.sass';
import template from './event-date-modal.tpl.pug';

class EventDateController {
    /* @ngInject */
    constructor(arrayUtil, stringUtil, eventUtil, modalService) {
        this.arrayUtil = arrayUtil;
        this.stringUtil = stringUtil;
        this.eventUtil = eventUtil;
        this.modalService = modalService;
    }

    $onInit() {
        this.unitOptions = [
            { id: this.eventUtil.EventRepeatUnit.Daily, value: 'Day' },
            { id: this.eventUtil.EventRepeatUnit.Weekly, value: 'Week' },
            { id: this.eventUtil.EventRepeatUnit.Monthly, value: 'Month' },
            { id: this.eventUtil.EventRepeatUnit.Yearly, value: 'Year' },
        ];

        this.endOptions = [
            { id: this.eventUtil.EventRepeatEndType.Never, value: 'Never' },
            { id: this.eventUtil.EventRepeatEndType.AfterOccurrence, value: 'After' },
            { id: this.eventUtil.EventRepeatEndType.OnDate, value: 'On' }
        ];

        this.timestamp = this.event.timestamp;
        this.repeating = !!this.event.repeat;
        this.previousRepeating = this.repeating;
        this.frequency = this.repeating ? this.event.repeat.frequency : 1;
        this.unit = this.repeating ? this.event.repeat.unit : this.eventUtil.EventRepeatUnit.Monthly;
        this.autoConfirm = this.repeating ? !!this.event.repeat.autoConfirm : false;
        this.endType = this.repeating
            ? this.event.repeat.end
                ? this.event.repeat.end.date
                    ? this.eventUtil.EventRepeatEndType.OnDate
                    : this.eventUtil.EventRepeatEndType.AfterOccurrence
                : this.eventUtil.EventRepeatEndType.Never
            : this.eventUtil.EventRepeatEndType.Never;
        this.endOccurrence = this.willEndAfterOccurrence ? this.event.repeat.end.occurrence : 4;
        this.endDate = this.willEndOnDate ? this.event.repeat.end.date : this.getEndDate(this.timestamp, this.frequency, this.unit, this.endOccurrence);
    }

    $doCheck() {
        if (this.previousRepeating && !this.repeating) {
            this.autoConfirm = false;
        }

        this.previousRepeating = this.repeating;
    }

    get occurrencePluralized() {
        return this.stringUtil.pluralize(this.endOccurrence, 'occurrence');
    }

    get willEnd() {
        return this.repeating && this.endType !== this.eventUtil.EventRepeatEndType.Never;
    }

    get willEndAfterOccurrence() {
        return this.repeating && this.endType === this.eventUtil.EventRepeatEndType.AfterOccurrence;
    }

    get willEndOnDate() {
        return this.repeating && this.endType === this.eventUtil.EventRepeatEndType.OnDate;
    }

    get summary() {
        let event = this.updateEvent(this.event);

        return [`${this.eventUtil.getRepeatingFrequencySummary(event.repeat)}${this.getRepeatingUnitDetail(event)}`, this.eventUtil.getRepeatingEndSummary(event.repeat)]
            .filter((summary) => summary && summary.length > 0)
            .join(', ');
    }

    getRepeatingUnitDetail(event) {
        let repeat = event.repeat || {};

        switch (repeat.unit) {
            case this.eventUtil.EventRepeatUnit.Weekly:
                return ` (on ${moment(event.timestamp).format('dddd')})`;
            case this.eventUtil.EventRepeatUnit.Monthly:
                return ` (on the ${moment(event.timestamp).format('Do')})`;
            case this.eventUtil.EventRepeatUnit.Yearly:
                return ` (on ${moment(event.timestamp).format('MMMM')} the ${moment(event.timestamp).format('Do')})`;
        }

        return '';
    }

    getDefaultEndOccurrence() {
        return 4;
    }

    getEndDate(timestamp, frequency, unit, endOccurrence) {
        return moment(timestamp).add(frequency * (endOccurrence - 1), unit).valueOf();
    }

    updateEvent(event) {
        return angular.merge({}, event, {
            timestamp: this.timestamp,
            repeat: this.repeating
                ? {
                    frequency: this.frequency,
                    unit: this.unit,
                    autoConfirm: !!this.autoConfirm,
                    end: this.willEnd ? {
                        date: this.willEndOnDate ? this.endDate : null,
                        occurrence: this.willEndAfterOccurrence ? this.endOccurrence : null
                    } : null
                }
                : null
        });
    }

    selectDate() {
        let endDate = this.willEndOnDate ? this.event.repeat.end.date : this.getEndDate(this.timestamp, this.frequency, this.unit, this.endOccurrence);

        return this.modalService.open({
            component: 'dbADateModal',
            bindings: {
                title: 'Date',
                startOfWeek: this.startOfWeek,
                timestamp: this.timestamp,
                onDayCheckDisabled: (timestamp) => timestamp > endDate
            }
        }).then((timestamp) => {
            this.timestamp = timestamp;
        }).catch(() => null);
    }

    selectEndDate() {
        return this.modalService.open({
            component: 'dbADateModal',
            bindings: {
                title: 'Repeat ends on',
                startOfWeek: this.startOfWeek,
                timestamp: this.endDate,
                onDayCheckDisabled: (timestamp) => timestamp < this.timestamp
            }
        }).then((timestamp) => {
            this.endDate = timestamp;
        }).catch(() => null);
    }

    dismiss() {
        return this.onDismiss();
    }

    close() {
        return this.onClose({
            data: this.updateEvent(this.event)
        });
    }
}

export default {
    selector: 'dbAEventDateModal',
    template: template(),
    controller: EventDateController,
    bindings: {
        event: '<',
        startOfWeek: '<',

        canEdit: '<',

        onClose: '&',
        onDismiss: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/modals/component/event-date-modal/event-date-modal.cmpt.js